import {
	employeesService,
	dashboardsService,
	workflowsService,
	groupsService,
} from "services";
import { toastr } from "react-redux-toastr";
import { errorFormating } from "utils/utils";

export const getAllEmployees = (options, signal) => async (dispatch) => {
	dispatch({ type: "LOADING" });

	try {
		const list = await employeesService.getAll(options, signal);

		dispatch({
			type: "GET_EMPLOYEES",
			payload: {
				data: list.data,
				pagination: list.pagination || {},
			},
		});
	} catch (error) {
		// No mostrar error si la petición fue cancelada
		if (error.name !== "AbortError") {
			console.log("Error: " + error.message);
			dispatch({
				type: "ERROR",
				payload: error.message,
			});
		}
	}
};

export const getSelectableEmployees = (options) => async (dispatch) => {
	try {
		const list = await employeesService.getSelectable(options);

		dispatch({
			type: "GET_SELECT_EMPLOYEES",
			payload: list.data,
		});
	} catch (error) {
		console.log("Error cargando empleados: " + error.message);
		dispatch({
			type: "ERROR",
			payload: error.message,
		});
	}
};

export const getEmployee = (id) => async (dispatch) => {
	dispatch({ type: "LOADING" });

	try {
		const user = await employeesService.getById(id);
		// console.log(user);
		dispatch({
			type: "GET_EMPLOYEE",
			payload: user,
		});
	} catch (error) {
		console.log("Error: " + error.message);
		dispatch({
			type: "ERROR",
			payload: error.message,
		});
	}
};

export const getEmployeeGroups = (employeeId) => async (dispatch) => {
	dispatch({ type: "LOADING" });

	try {
		const list = await employeesService.getGroups(employeeId);

		dispatch({
			type: "GET_EMPLOYEE_GROUPS",
			payload: list,
		});
	} catch (error) {
		console.log("Error: " + error.message);
		dispatch({
			type: "ERROR",
			payload: error.message,
		});
	}
};

export const getEmployeeFunctions = (employeeId) => async (dispatch) => {
	dispatch({ type: "LOADING" });

	try {
		const list = await employeesService.getFunctions(employeeId);

		dispatch({
			type: "GET_EMPLOYEE_FUNCTIONS",
			payload: list,
		});
	} catch (error) {
		console.log("Error: " + error.message);
		dispatch({
			type: "ERROR",
			payload: error.message,
		});
	}
};

export const getEmployeeUbications = (employeeId) => async (dispatch) => {
	dispatch({ type: "LOADING" });

	try {
		const list = await employeesService.getUbications(employeeId);

		dispatch({
			type: "GET_EMPLOYEE_UBICATIONS",
			payload: list,
		});
	} catch (error) {
		console.log("Error: " + error.message);
		dispatch({
			type: "ERROR",
			payload: error.message,
		});
	}
};

export const getEmployeeShiftPatterns = (employeeId) => async (dispatch) => {
	dispatch({ type: "LOADING" });

	try {
		const list = await employeesService.getShiftPatterns(employeeId);

		if (!list.ok) {
			// Mostrar errores en toast
			const formatted = errorFormating(list);
			const errorMessage =
				formatted?.general ||
				list?.errors?.[0]?.description ||
				"Ha ocurrido un error al cargar las ruedas de turnos";
			toastr.error("Error", errorMessage);

			// Despachar lista vacía para evitar errores en el componente
			dispatch({
				type: "GET_EMPLOYEE_SHIFT_PATTERNS",
				payload: [],
			});
		} else {
			dispatch({
				type: "GET_EMPLOYEE_SHIFT_PATTERNS",
				payload: list,
			});
		}
	} catch (error) {
		console.log("Error: " + error.message);
		toastr.error(
			"Error",
			"Ha ocurrido un error al cargar las ruedas de turnos"
		);
		dispatch({
			type: "ERROR",
			payload: error.message,
		});
		// Despachar lista vacía para evitar errores en el componente
		dispatch({
			type: "GET_EMPLOYEE_SHIFT_PATTERNS",
			payload: [],
		});
	}
};

export const getEmployeeContracts = (employeeId) => async (dispatch) => {
	dispatch({ type: "LOADING" });

	try {
		const list = await employeesService.getContracts(employeeId);

		dispatch({
			type: "GET_EMPLOYEE_CONTRACTS",
			payload: list,
		});
	} catch (error) {
		console.log("Error: " + error.message);
		dispatch({
			type: "ERROR",
			payload: error.message,
		});
	}
};

export const getEmployeeDocuments = (employeeId) => async (dispatch) => {
	dispatch({ type: "LOADING" });

	try {
		const employee = await employeesService.getById(employeeId);

		dispatch({
			type: "GET_EMPLOYEE_DOCUMENTS",
			payload: employee.attachments || [],
		});
	} catch (error) {
		console.log("Error: " + error.message);
		dispatch({
			type: "ERROR",
			payload: error.message,
		});
	}
};

export const getEmployeeAbsences = (employeeId) => async (dispatch) => {
	dispatch({ type: "LOADING" });

	try {
		const list = await workflowsService.getAllAbsences({
			employee_id: employeeId,
		});

		dispatch({
			type: "GET_EMPLOYEE_ABSENCES",
			payload: list.data,
		});
	} catch (error) {
		console.log("Error: " + error.message);
		dispatch({
			type: "ERROR",
			payload: error.message,
		});
	}
};

export const getEmployeePreferences = (employeeId) => async (dispatch) => {
	dispatch({ type: "LOADING" });

	try {
		const list = await workflowsService.getAllPreferences({ employeeId });
		// console.log(list);

		dispatch({
			type: "GET_EMPLOYEE_PREFERENCES",
			payload: list.data,
		});
	} catch (error) {
		console.log("Error: " + error.message);
		dispatch({
			type: "ERROR",
			payload: error.message,
		});
	}
};

export const getEmployeeAbsenceCalendar =
	(employeeId, year) => async (dispatch) => {
		dispatch({ type: "LOADING" });

		try {
			const list = await dashboardsService.getEmployeeAbsenceCalendar(
				employeeId,
				year
			);
			// `handleResponse` resuelve incluso con HTTP 500; en ese caso `list.ok` será false.
			// Si no lo tratamos como error, `AbsenceCalendar` puede quedarse en `loading`.
			if (list && list.ok === false) {
				throw new Error(
					list?.errors?.[0]?.description ||
						list?.error ||
						"Error cargando el calendario."
				);
			}
			// console.log(list);

			dispatch({
				type: "GET_EMPLOYEE_ABSENCE_CALENDAR",
				// Si la API responde con error, `list.days` puede ser `undefined`.
				// Mantenemos el estado siempre como array para evitar crasheos por `.length`.
				payload: list?.days ?? [],
			});
		} catch (error) {
			console.log("Error: " + error.message);
			dispatch({
				type: "ERROR",
				payload: error.message,
			});
		}
	};

export const getEmployeeSeparatedRestEmployees =
	(employeeId) => async (dispatch) => {
		dispatch({ type: "LOADING" });

		try {
			const list =
				await employeesService.getSeparatedRestsEmployees(employeeId);
			// console.log(list);

			dispatch({
				type: "GET_EMPLOYEE_SEPARATED_REST",
				payload: list,
			});
		} catch (error) {
			console.log("Error: " + error.message);
			dispatch({
				type: "ERROR",
				payload: error.message,
			});
		}
	};

export const getEmployeeSeparatedRestBackup =
	(employeeId) => async (dispatch) => {
		dispatch({ type: "LOADING" });

		try {
			const backup = await employeesService.getSeparatedRestsBackup(employeeId);
			// console.log(backup);

			dispatch({
				type: "GET_EMPLOYEE_BACKUP",
				payload: backup,
			});
		} catch (error) {
			console.log("Error: " + error.message);
			dispatch({
				type: "ERROR",
				payload: error.message,
			});
		}
	};

export const getEmployeeRestrictedShifts = (employeeId) => async (dispatch) => {
	dispatch({ type: "LOADING" });

	try {
		const list =
			await employeesService.getRestrictedShiftsEmployees(employeeId);

		dispatch({
			type: "GET_EMPLOYEE_RESTRICTED_SHIFTS",
			payload: list,
		});
	} catch (error) {
		console.log("Error: " + error.message);
		dispatch({
			type: "ERROR",
			payload: error.message,
		});
	}
};

export const updateEmployeeInState = (employee) => (dispatch) => {
	dispatch({
		type: "UPDATE_EMPLOYEE_IN_STATE",
		payload: employee,
	});
};

export const clearEmployeeState = () => (dispatch) => {
	dispatch({
		type: "CLEAR_EMPLOYEE_STATE",
	});
};
